import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    html {
        scroll-behavior: smooth;
    }

    html.normal-scroll {
        scroll-behavior: auto;
    }

    *,
    *::after,
    *::before {
        box-sizing: border-box;
    }

    .noScroll {
        overflow: hidden !important;
    }

    body {
        margin: 0;
        padding: 0;
        background: #fff;
        font-family: 'Montserrat';

    }

    a {
        text-decoration: inherit;
        color: inherit;
        @media (min-width: 720px) {
            cursor: pointer;
        }
    }

    #myBogoPopup {
        @media (min-width: 720px) {
            inset: 50% auto auto 50% !important;
            transform: translate(-50%, -50%) !important;
        }
    }

    a:visited {
        text-decoration: inherit;
        color: inherit;
        @media (min-width: 720px) {
            cursor: pointer;
        }
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    ol {
        margin: 0;
        padding: 0;
    }

    h1, h2, h3, h4, h5, h6, p {
        margin: 0;
    }

    a {
        text-decoration: none;
    }


    .moe-main-class {
        display: none;
        height: 100%;
        position: fixed;
        top: 0;
        z-index: 999;
        width: 100%;
        background: #000000ab;
        transition: all 1s ease-in;
        @media (min-width: 720px) {
            visibility: hidden;
        }
    }

    #productId {
        border-collapse: collapse;
        width: 80%;
        margin-top: 30px;
    }

    #productId td, #productId th {
        border: 1px solid #ddd;
        padding: 8px;
    }

    #productId thead:nth-child(even) {
        background-color: #f2f2f2;
    }

    #productId th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #f2f2f2
    }

    .read_more {
        display: block;
        color: #63b0a8 !important;
        margin-top: 6px;
    }

    .aplusopen {
        & .aplusplusheading {
            border-bottom: solid 1px hsl(0deg, 0%, 0%, 64%);

            &:after {
                transform: rotate(270deg);
            }
        }
    }

    .triggerClassAplus {
        .rotateImageAplus {
            transform: rotate(270deg);
        }

        .aplusTitleSize {
            font-size: clamp(16px, 2vw, 18px);
            font-weight: 600;
        }
    }

    .snap-emi-slogan {
        display: none;
    }

    .defaultanchor {
        text-decoration: initial;
        color: blue;
        @media (min-width: 720px) {
            cursor: pointer;
        }

    }

    .shareModal {
        position: absolute !important;
        bottom: -100px !important;
        transition: transform 500ms ease-in-out !important;
        outline: none !important;
    }

    .shareModalOpen {
        transform: translate(0, -100px) !important;
    }

    .shareModalClose {
        transform: translate(0, 150%) !important;
    }

    .bottomSheetProduct {
        position: absolute !important;
        bottom: -100% !important;
        transition: transform 500ms ease-in-out !important;
        outline: none !important;
    }

    .bottomSheetProductPdp {
        position: absolute !important;
        transition: transform 500ms ease-in-out !important;
        outline: none !important;
    }

    .bottomSheetPack {
        position: absolute !important;
        bottom: 0 !important;
        outline: none !important;
        border-top-left-radius: 20px !important;
        border-top-right-radius: 20px !important;
        transition: transform 500ms ease-in-out !important;
        outline: none !important;
        transform: translate(0, 100%) !important;
        padding: 34px 0 0 0 !important;
    }

    .bottomSheetPackOpen {
        transform: translate(0, 0%) !important;
    }

    .bottomSheetProductOpen {
        transform: translate(0, -100px) !important;
    }

    .bottomSheetProductClose {
        transform: translate(0, 150%) !important;
    }

    .consultModal {
        position: absolute !important;
        bottom: -600px !important;
        transition: transform 500ms ease-in-out !important;
        outline: none !important;
    }

    .consultModalOpen {
        transform: translate(0, -600px) !important;
        min-width: 80%;
    }

    .consultModalClose {
        transform: translate(0, 150%) !important;
    }

    .noScroll {
        overflow: hidden !important;
    }

    .sectionTitle {
        font-size: clamp(16px, 2vw, 18px);
        font-weight: bold;
        padding-left: 10px;
        @media (min-width: 768px) {
            padding-left: 0px;
        }
        letter-spacing: 1px;
        text-transform: uppercase;
        padding-bottom: 16px;
    }
`;
export default GlobalStyle;
